import { ROLE } from "@types/role";

export const BlankRoleData: ROLE = {
  id: "",
  role_type: "",
  name: "未選択",
  created_at: "",
  updated_at: "",
};
